import React from 'react';
import LoginSceen from '../../components/LoginSceen/login';
import AuthForm from './authForm';

const Login = (props) => {
    return(
       <LoginSceen>
            <AuthForm onSubmit={props.onSubmit} loadStatus={props.loadStatus} onReturn={props.onReturn} />
       </LoginSceen>
    )
}

export default Login;